import axios from "axios";
import { API_BASE_URL } from "../../config";

const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

/**
 * Fetch the BSP Register Ticket Report.
 * @param {Object} filters - { start_date, end_date, airline, ticket_status, customer_name, search_query }
 */
export const getBSPRegisterReport = async (filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters).filter(([, v]) => v !== "" && v !== null && v !== undefined)
  );
  const response = await axios.get(`${BASE}/reports/bsp-register`, { params });
  return response.data;
};
